import { OnboardingGetStartedRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/onboarding/get-started')({
  component: OnboardingGetStartedRoute,
});
